var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5182 2.5473L25.3604 19.5946C25.8129 20.3784 25.2473 21.3581 24.3423 21.3581H4.65774C3.7527 21.3581 3.18706 20.3784 3.63957 19.5946L13.4818 2.5473C13.9344 1.76351 15.0656 1.76351 15.5182 2.5473Z",
    fill: "currentFill",
    stroke: "white",
    strokeWidth: 0.783784
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4903 9.92235L15.2883 16.113H13.8187L13.6105 9.92235H15.4903ZM13.5615 18.0296C13.5615 17.7684 13.6513 17.552 13.8309 17.3805C14.0146 17.205 14.2555 17.1172 14.5535 17.1172C14.8556 17.1172 15.0964 17.205 15.276 17.3805C15.4556 17.552 15.5454 17.7684 15.5454 18.0296C15.5454 18.2827 15.4556 18.497 15.276 18.6726C15.0964 18.8481 14.8556 18.9359 14.5535 18.9359C14.2555 18.9359 14.0146 18.8481 13.8309 18.6726C13.6513 18.497 13.5615 18.2827 13.5615 18.0296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.52e87c52a9a7b1fe5f4c65e6cd607795.svg";
export { ForwardRef as ReactComponent };